/**
 * QueensGiant assumption sets: frozen, numbered copies of a deal's stage numbers.
 * Publish creates vN as DRAFT; a second user approves it; a new tape marks it STALE.
 * The numbers are computed by Lightdash from the compiled stage YAML; this only
 * stores what was on screen and who signed it off.
 */
export var AssumptionSetStatus;
(function (AssumptionSetStatus) {
    AssumptionSetStatus["DRAFT"] = "DRAFT";
    AssumptionSetStatus["APPROVED"] = "APPROVED";
    AssumptionSetStatus["STALE"] = "STALE";
})(AssumptionSetStatus || (AssumptionSetStatus = {}));
//# sourceMappingURL=assumptionSets.js.map